export default "__VITE_ASSET__1e88e1e3__"